import _typeof from "@babel/runtime/helpers/typeof";

/*
 This backend logs a sentry event for every task failure
 */
import { LABEL_GENERIC_TASK } from "../events";

/**
 * Serializes primitive objects or Error instances
 */
// eslint-disable-next-line flowtype/no-weak-types -- Error thrown can be of any type
function stringifyError(error) {
  if (error && _typeof(error) === 'object') {
    var errorObject = {};
    Object.getOwnPropertyNames(error).forEach(function (key) {
      errorObject[key] = _typeof(error[key]) === 'object' ? stringifyError(error[key]) : error[key];
    });
    return JSON.stringify(errorObject);
  }

  return JSON.stringify(error);
}

var createListener = function createListener() {
  return function (event, getContext) {
    switch (event.type) {
      case LABEL_GENERIC_TASK:
        {
          if (!event.successful && window.Sentry) {
            var context = getContext();
            window.Sentry.withScope(function (scope) {
              scope.setLevel('error');
              scope.setTag('page', context.page);
              scope.setTag('task', event.task);
              scope.setTag('taskId', event.taskId);
              var cause = event.cause;

              if (cause) {
                scope.setExtra('cause', stringifyError(cause));
              }

              window.Sentry.captureMessage("Telemetry task failed: ".concat([event.task, event.taskId].filter(function (a) {
                return !!a;
              }).join(',')));
            });
          }
        }
    }
  };
};

export default createListener;